import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'af',
  months: [
    'Januarie',
    'Februarie',
    'Maart',
    'April',
    'Mei',
    'Junie',
    'Julie',
    'Augustus',
    'September',
    'Oktober',
    'November',
    'Desember',
  ],
  monthsShort: ['Jan', 'Feb', 'Mrt', 'Apr', 'Mei', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Des'],
  weekdays: ['Sondag', 'Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrydag', 'Saterdag'],
  weekdaysMin: ['So', 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Sa'],
  weekdaysShort: ['So', 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Sa'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'h:mm A',
    lts: 'h:mm:ss A',
    L: 'D/M/YYYY',
    LL: 'D MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM YYYY, HH:mm',
    'LLL-Y': 'D MMMM HH:mm',
    LLLL: 'dddd, D MMMM YYYY, HH:mm',
    'LLLL-Y': 'dddd, D MMMM, HH:mm',
    l: 'D/M/YYYY',
    'l-Y': 'D/M',
    ll: 'D MMM YYYY',
    'll-Y': 'D MMM',
    'll-D': 'MMM YYYY',
    lll: 'D MMM YYYY h:mm A',
    'lll-Y': 'D MMM h:mm A',
    llll: 'ddd, D MMM YYYY, h:mm A',
    'llll-Y': 'ddd, D MMM, h:mm A',
    'll-Y+w': 'ddd, D MMM',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'DD MMMM YYYY, HH:mm ([GMT]Z)',
  },
  meridiem: { am: 'vm.', pm: 'nm.', AM: 'vm.', PM: 'nm.' },
  past: {
    y: { one: '%s j. gelede', other: '%s j. gelede' },
    M: { one: '%s md. gelede', other: '%s md. gelede' },
    w: { one: '%s w. gelede', other: '%s w. gelede' },
    d: { one: '%s dag gelede', other: '%s dae gelede' },
    h: { one: '%s u. gelede', other: '%s u. gelede' },
    m: { one: '%s min. gelede', other: '%s min. gelede' },
    s: { one: '%s s. gelede', other: '%s s. gelede' },
  },
  future: {
    y: { one: 'oor %s j.', other: 'oor %s j.' },
    M: { one: 'oor %s md.', other: 'oor %s md.' },
    w: { one: 'oor %s w.', other: 'oor %s w.' },
    d: { one: 'oor %s dag', other: 'oor %s dae' },
    h: { one: 'oor %s u.', other: 'oor %s u.' },
    m: { one: 'oor %s min.', other: 'oor %s min.' },
    s: { one: 'oor %s s.', other: 'oor %s s.' },
  },
  pastLong: {
    y: { one: '%s jaar gelede', other: '%s jaar gelede' },
    M: { one: '%s maand gelede', other: '%s maande gelede' },
    w: { one: '%s week gelede', other: '%s weke gelede' },
    d: { one: '%s dag gelede', other: '%s dae gelede' },
    h: { one: '%s uur gelede', other: '%s uur gelede' },
    m: { one: '%s minuut gelede', other: '%s minute gelede' },
    s: { one: '%s sekonde gelede', other: '%s sekondes gelede' },
  },
  futureLong: {
    y: { one: 'oor %s jaar', other: 'oor %s jaar' },
    M: { one: 'oor %s maand', other: 'oor %s maande' },
    w: { one: 'oor %s week', other: 'oor %s weke' },
    d: { one: 'oor %s dag', other: 'oor %s dae' },
    h: { one: 'oor %s uur', other: 'oor %s uur' },
    m: { one: 'oor %s minuut', other: 'oor %s minute' },
    s: { one: 'oor %s sekonde', other: 'oor %s sekondes' },
  },
  abbr: {
    y: { one: '%s j.', other: '%s j.' },
    M: { one: '%s md.', other: '%s md.' },
    w: { one: '%s w.', other: '%s w.' },
    d: { one: '%s dag', other: '%s dae' },
    h: { one: '%s u.', other: '%s u.' },
    m: { one: '%s min.', other: '%s min.' },
    s: { one: '%s s.', other: '%s s.' },
  },
  full: {
    y: { one: '%s jaar', other: '%s jaar' },
    M: { one: '%s maand', other: '%s maande' },
    w: { one: '%s week', other: '%s weke' },
    d: { one: '%s dag', other: '%s dae' },
    h: { one: '%s uur', other: '%s uur' },
    m: { one: '%s minuut', other: '%s minute' },
    s: { one: '%s sekonde', other: '%s sekondes' },
  },
  justNow: 'So pas',
  yesterday: 'Gister',
  today: 'Vandag',
  tomorrow: 'Môre',
  weekStart: 0,
  timeRange: '%$1s – %$2s',
  timeZone: '%$1s %$2s',
  timePref: {},
  timeRangeStyles: {
    yl: { start: 'DD MMMM YYYY', end: 'DD MMMM YYYY' },
    'yl-1': { start: 'D MMMM', end: 'DD MMMM YYYY' },
    ml: { start: 'D MMMM', end: 'D MMMM' },
    'ml-1': { start: 'D', end: 'D MMMM YYYY' },
    dl: { start: 'D', end: 'D MMMM' },
    y: { start: 'D MMM YYYY', end: 'D MMM YYYY' },
    'y-1': { start: 'D MMM', end: 'D MMM YYYY' },
    m: { start: 'D MMM', end: 'D MMM' },
    'm-1': { start: 'D', end: 'D MMM YYYY' },
    d: { start: 'D', end: 'D MMM' },
    Y: { start: 'ddd D MMM YYYY', end: 'ddd D MMM YYYY' },
    'Y-1': { start: 'ddd D MMM', end: 'ddd D MMM YYYY' },
    M: { start: 'ddd D MMM', end: 'ddd D MMM' },
    D: { start: 'ddd D MMM', end: 'ddd D MMM' },
    yt: { start: 'D MMM YYYY HH:mm', end: 'D MMM YYYY HH:mm' },
    mt: { start: 'D MMM HH:mm', end: 'D MMM HH:mm' },
    dt: { start: 'D MMM HH:mm', end: 'D MMM HH:mm' },
    t: { start: 'HH:mm', end: 'HH:mm' },
    'yt+to': { start: 'D MMM YYYY HH:mm', end: 'D MMM YYYY HH:mm ([GMT]Z)' },
    'mt+to': { start: 'D MMM HH:mm', end: 'D MMM HH:mm ([GMT]Z)' },
    'dt+to': { start: 'D MMM HH:mm', end: 'D MMM HH:mm ([GMT]Z)' },
    't+to': { start: 'HH:mm', end: 'HH:mm ([GMT]Z)' },
  },
};
const localeName: LocaleName = 'af';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (n) => `${n}`,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'vm.' : 'vm.';
    } else {
      return isLowerCase ? 'nm.' : 'nm.';
    }
  },
};
